import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewCase from './pages/NewCase';
import CaseList from './pages/CaseList';
import CaseDetail from './pages/CaseDetail';

import Users from './pages/Users';



const PrivateRoute = ({ children }) => {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/cases" element={<PrivateRoute><CaseList /></PrivateRoute>} />
        <Route path="/cases/new" element={<PrivateRoute><NewCase /></PrivateRoute>} />
        <Route path="/cases/:id" element={<PrivateRoute><CaseDetail /></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}